import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component } from '@eastsideco/salvo-ts';
import Swiper from 'swiper';
import 'swiper/css/bundle';

@Component
export class SuccessFilters extends ThemeComponent {

    private filters: NodeListOf<HTMLButtonElement> | null;
    private swiper: Swiper | undefined;
    private cards: NodeListOf<HTMLElement> | null;

    constructor() {
        super();
        this.filters = document.querySelectorAll('.success-filter');
        this.cards = document.querySelectorAll<HTMLDivElement>(`.js-success-card`);
    }

    init() {
        this.activeFilter(this.filters);

        this.swiper = new Swiper('.product-filter-swiper', {
            slidesPerView: 3.5,
            spaceBetween: 10,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        this.checkAndToggleSwiper();

        window.addEventListener('resize', this.checkAndToggleSwiper.bind(this));

        if (this.swiper) {
            this.swiper.on('slideChange', () => {
                this.swiper?.pagination.render();
                this.swiper?.pagination.update();
            });

            this.nextArrow();
        }

        this.applyQueryFilters();
    }

    activeFilter(filters: NodeListOf<HTMLButtonElement> | null) {
        if (!filters) { return; }

        for (const filter of filters) {
            this.$listen(filter, 'click',  () => {
                const data = filter.dataset.successFilter;
                const parent = data?.split('-')[0];
                const elems = document.querySelectorAll(`.${parent}-filters .success-filter`);

                for (const element of elems) { element.classList.remove('button--active'); }
                filter.classList.add('button--active');

                this.displaySuccessCards();
            });
        }
    }

    displaySuccessCards() {
        if (!this.cards) { return; }

        const activeFilters = document.querySelectorAll<HTMLElement>('.success-filter.button--active');
        const filterValues = Array.from(activeFilters).map((filter) => filter.dataset.filter);

        if (filterValues && filterValues[0] === 'all' && filterValues[1] === 'all') {
            for (const [index, card] of this.cards.entries()) {
                if (card.parentElement) {
                    card.parentElement.dataset.filtered = 'false';

                    // First 2 items will be shown when both filters are set to 'all'
                    if (index < 2) {
                        card.parentElement.classList.add('is-active');
                    } else {
                        card.parentElement.classList.remove('is-active');
                    }
                }
            }

            // Event dispatched for use with 'SuccessLoadMore' component
            document.dispatchEvent(new Event('successCardsReset'));
        } else {
            let activeCardCount = 0;

            for (const card of this.cards) {
                if (
                    card.dataset.mainFilters?.includes(filterValues[0] || '') &&
                    card.dataset.productFilters?.includes(filterValues[1] || '')
                ) {
                    if (activeCardCount < 2) {
                        card.parentElement?.classList.add('is-active');
                    }

                    if (card.parentElement) {
                        card.parentElement.dataset.filtered = 'true';
                    }

                    activeCardCount++;
                } else {
                    card.parentElement?.classList.remove('is-active');

                    if (card.parentElement) {
                        card.parentElement.dataset.filtered = 'false';
                    }
                }
            }

            // Event dispatched for use with 'SuccessLoadMore' component
            document.dispatchEvent(new Event('successCardsFiltered'));
        }
    }

    checkAndToggleSwiper() {
        const screenWidth = window.innerWidth;

        if (this.swiper) {
            if (screenWidth > 600) {
                this.swiper.disable();
            } else {
                this.swiper.enable();
            }
        }
    }

    nextArrow() {
        const svg = document.querySelector<HTMLElement>('.product-filter-swiper svg');
        if (svg) {
            this.$listen(svg, 'click', async() => {
                if(this.swiper) {
                    this.swiper.slideNext();
                }
            });
        }
    }

    applyQueryFilters() {
        const urlParams = new URLSearchParams(window.location.search);
        const successFilter = urlParams.get('type-filter');
        const productFilter = urlParams.get('product-filter');

        if (successFilter && productFilter) {
            const filtersToApply = [successFilter, productFilter];
            this.displaySuccessCardsBasedOnQuery(filtersToApply);

            const allTypeFilters = document.querySelectorAll('.story-filters .success-filter');
            const allProductFilters = document.querySelectorAll('.product-filters .success-filter');

            const allFilters =
                document.querySelectorAll('.story-filters .success-filter, .product-filters .success-filter');
            for (const item of allFilters) {
                item.classList.remove('button--active');
            }

            for (const item of allTypeFilters) {
                const typeFilter = item.getAttribute('data-success-filter');
                if (typeFilter?.includes(successFilter)) {
                    item.classList.add('button--active');
                }
            }

            for (const item of allProductFilters) {
                const typeFilter = item.getAttribute('data-success-filter');
                if (typeFilter?.includes(productFilter)) {
                    item.classList.add('button--active');
                }
            }
        }
    }

    displaySuccessCardsBasedOnQuery(filtersToApply: string[]) {
        if (!this.cards) { return; }

        for (const card of this.cards) {
            const mainFilters = card.dataset.mainFilters?.split(',') || [];
            const productFilters = card.dataset.productFilters?.split(',') || [];

            const matchesFilters = mainFilters.includes(filtersToApply[0])
                && productFilters.includes(filtersToApply[1]);

            if (matchesFilters) {
                card.parentElement?.classList.add('is-active');

                if (card.parentElement) {
                    card.parentElement.dataset.filtered = 'true';
                }
            } else {
                card.parentElement?.classList.remove('is-active');

                if (card.parentElement) {
                    card.parentElement.dataset.filtered = 'false';
                }
            }
        }

        // Event dispatched for use with 'SuccessLoadMore' component
        document.dispatchEvent(new Event('successCardsFiltered'));
    }
}
